import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ListCategories, deleteCategory } from "../../actions/categoryAction";
import Pagination from "../Pagination/Pagination";
import Axios from "../../axios/axios";
import ConfirmationModal from "../utils/ConfirmationModal";

const ListCategory = () => {
  const dispatch = useDispatch();

  const [perPage] = useState(10);
// modal state
const [showModal, setShowModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);

  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [categories, setCategories] = useState([]);
  const catList = useSelector((state) => state.catList);
  // const { loading, error, categories, page, pages } = catList;
  // const { categories, page: currentPage, pages, loading, error } = catList;
const spanStyle = {
  whiteSpace: "normal",
  wordWrap: "break-word",
  lineHeight: "25px",
};
  console.log(catList);

  const catDelete = useSelector((state) => state.catDelete);

  const [pageNumber, setPageNumber] = useState(1);

  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = catDelete;

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  useEffect(() => {
    fetchCategory();
  }, [page, keyword]);

const fetchCategory = async () => {
  try {
    const res = await Axios.get(
      `/api/category?pageNumber=${page}&pageSize=${pageSize}&keyword=${keyword}`
    );
    console.log(res.status, res.data.categories, "category response");
    if (res.status >= 200 && res.status < 300) {
      setCategories(res.data.categories);
      setTotalCount(res.data.count);
    }
  } catch (error) {
    console.error("Error fetching categories", error);
  }
};


  console.log(categories, "categories");

const deleteHandler = (id) => {
  dispatch(deleteCategory(id));
  fetchCategory(); // refresh the list after deletion
};




  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div className="col-sm-6 col-lg-12 col-md-8">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Category List</h4>
              <div class="float-right">
                <Link to="/category/create">
                  {" "}
                  <button
                    type="button"
                    class="btn btn-primary btn-md btn-block"
                  >
                    <i class="icon-plus menu-icon"></i>
                    Create
                  </button>
                </Link>
              </div>

              <div className="mb-3 d-flex justify-content-between">
                <input
                  type="text"
                  placeholder="Search  by category name"
                  className="form-control w-25"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1); // Reset to first page on new filter
                  }}
                />
              </div>
<div className="justify-content-center d-flex">{/* Pagination */}
                <Pagination
                  page={page}
                  perPage={perPage}
                  setPage={setPage}
                  totalCount={totalCount}
                /></div>
                <br/>
              <div class="table-container">
                <table class="table table-striped table-fixed">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Category Name</th>
                      <th>Title</th>
                      <th> Priory</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((cat, index) => (
                      <tr>
                        <td>{(page - 1) * pageSize + index + 1}</td>
                        <td><span style={spanStyle}>{cat?.categoryName}</span></td>
                        <td><span style={spanStyle}>{cat?.title}</span></td>
                        <td><span style={spanStyle}>{cat?.priority}</span></td>
                        <td>
  <div className="d-flex gap-2 align-items-center">
    <Link to={`/category/edit/${cat?._id}`}>
      <button
        type="button"
        className="btn btn-outline-dark btn-sm"
      >
        Edit
      </button>
    </Link>

    <button
  type="button"
  className="btn btn-outline-danger btn-sm"
  onClick={() => {
    setDeleteId(cat?._id);
    setShowModal(true);
  }}
>
  Delete
</button>

  </div>
</td>

                      </tr>
                    ))}
                  </tbody>
                </table>

                
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
  show={showModal}
  onHide={() => setShowModal(false)}
  onConfirm={() => {
    deleteHandler(deleteId);
    setShowModal(false);
  }}
  title="Delete Category"
  message="Are you sure you want to delete this category?"
/>

    </div>
  );
};

export default ListCategory;
